import { render } from "./StandardModal.vue?vue&type=template&id=6bf05273"
import script from "./StandardModal.vue?vue&type=script&lang=js"
export * from "./StandardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__